import React from 'react'

export default function tableRows(children) {
    const list = React.Children.toArray(children)
    const rows = []
    const rest = []
    list.forEach((child) => {
        const typeName = child && child.type && (child.type.displayName || child.type.name)
        if (typeName === 'Tr') rows.push(child)
        else rest.push(child)
    })
    return (
        <>
            {rest}
            {rows.length > 0 && <tbody>{rows}</tbody>}
        </>
    )
}
